import { openDB, type IDBPDatabase } from "idb";

interface FitnessDB {
  cache: { key: string; value: unknown; updatedAt: number };
  pendingSessionUpdates: { id: string; sessionId: string; payload: unknown; queuedAt: number };
}

let dbp: Promise<IDBPDatabase> | null = null;

export const db = () => {
  if (!dbp) {
    dbp = openDB("fitness", 1, {
      upgrade(d) {
        if (!d.objectStoreNames.contains("cache")) d.createObjectStore("cache", { keyPath: "key" });
        if (!d.objectStoreNames.contains("pendingSessionUpdates"))
          d.createObjectStore("pendingSessionUpdates", { keyPath: "id" });
      },
    });
  }
  return dbp;
};

export const cacheGet = async <T>(key: string): Promise<T | undefined> => {
  const d = await db();
  const item = await d.get("cache", key);
  return item?.value as T | undefined;
};

export const cacheSet = async (key: string, value: unknown) => {
  const d = await db();
  await d.put("cache", { key, value, updatedAt: Date.now() });
};

export const enqueueSessionUpdate = async (sessionId: string, payload: unknown) => {
  const d = await db();
  await d.put("pendingSessionUpdates", {
    id: `${sessionId}#${Date.now()}`,
    sessionId,
    payload,
    queuedAt: Date.now(),
  });
};

export const drainPendingSessionUpdates = async () => {
  const d = await db();
  const all = await d.getAll("pendingSessionUpdates");
  await d.clear("pendingSessionUpdates");
  return all;
};
